import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';
import Sublink from '~/data/strapi/types/shared-components/link/sub-link';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';

interface Props {
  data: Sublink;
  isActive?: boolean;
  className?: string;
  parentHref: string | null;
}

const HeaderSublink: FC<Props> = ({ data, isActive, className, parentHref }) => {
  const href = data.href;
  const title = data.title;
  const sublinks = data.links;

  if (!href || !title) {
    return null;
  }

  const totalHref = parentHref ? `/${parentHref}/${href}` : `/${href}`;

  return (
    <Link href={totalHref} className={clsx(styles.sublink, isActive && styles.active, className)}>
      <span className={styles.text} dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }} />
      {sublinks?.length ? <Icon name="chevron" className={styles.icon} /> : <></>}
    </Link>
  );
};

export default HeaderSublink;
